import {
  futureSummary,
  selectedHistory,
  statisticObservation,
  conversionObservation,
} from "./teamAnalysis";
export function leagueParameterColumns(
  data,
  en = false,
  statName = (k) => k,
  { recent = 0, venue = "overall" } = {}
) {
  const t = (d, e) => (en ? e : d),
    out = [];
  const resultFields = {
    total_strength: t("Spielstärke · Quotient", "Strength · ratio"),
    total_goals: t("Toreschnitt", "Goals/game"),
    for_total: t("Für · Gesamt", "For · overall"),
    against_total: t("Gegen · Gesamt", "Against · overall"),
    for_home: t("Heim · Für", "Home · for"),
    against_home: t("Heim · Gegen", "Home · against"),
    for_away: t("Auswärts · Für", "Away · for"),
    against_away: t("Auswärts · Gegen", "Away · against"),
    for_homefactor: t("Offensiver Heimfaktor", "Attacking home factor"),
    against_homefactor: t("Defensiver Heimfaktor", "Defensive home factor"),
    draw_factor: t("Remisfaktor", "Draw factor"),
  };
  for (const model of ["result", "statistics"])
    for (const [field, label] of Object.entries(resultFields)) {
      out.push({
        key: model + ":" + field,
        label:
          (model === "result"
            ? t("Ergebnismodell · gespeichert", "Results model · saved")
            : t("Statistikmodell · gespeichert", "Statistics model · saved")) +
          " · " +
          label,
        value: (id) =>
          futureSummary(
            model === "result" || field === "draw_factor"
              ? data?.result_teams?.[id]
              : data?.ranking?.find((r) => r.team_id === Number(id))
          )?.[field],
      });
    }
  const fields = {
    home_for: t("Heim · Für", "Home · for"),
    home_against: t("Heim · Gegen", "Home · against"),
    away_for: t("Auswärts · Für", "Away · for"),
    away_against: t("Auswärts · Gegen", "Away · against"),
  };
  const keys = [
    ...new Set([
      ...Object.keys(data?.state?.reference?.statistics || {}),
      ...Object.values(data?.state?.teams || {}).flatMap((t) =>
        Object.keys(t.statistics || {})
      ),
    ]),
    "conversion",
  ];
  for (const key of keys)
    for (const [field, label] of Object.entries(fields))
      for (const source of ["saved", "observed", "expected"]) {
        const percent = key === "conversion" || Number(key) === 45;
        out.push({
          key: `${source}:${key}:${field}`,
          label:
            (source === "saved"
              ? t("Statistikmodell · gespeichert", "Statistics model · saved")
              : source === "observed"
              ? t("Erspielt", "Observed")
              : t("Bisher erwartet", "Expected so far")) +
            " · " +
            (key === "conversion" ? "Conversion" : statName(key)) +
            " · " +
            label +
            (percent ? " (%)" : ""),
          value: (id) => {
            if (source === "saved") {
              const team = data?.state?.teams?.[id];
              const v =
                key === "conversion"
                  ? team?.conversion?.[field]
                  : team?.statistics?.[key]?.[field];
              return Number.isFinite(v) ? v * (percent ? 100 : 1) : null;
            }
            let games = selectedHistory(data?.observations || [], id).filter(
              (g) => venue === "overall" || g[venue + "_team_id"] === Number(id)
            );
            if (recent) games = games.slice(0, recent);
            const v =
              key === "conversion"
                ? conversionObservation(games, id, field, source === "expected")
                    .mean
                : statisticObservation(
                    games,
                    id,
                    key,
                    field,
                    source === "expected"
                  ).mean;
            return Number.isFinite(v)
              ? percent
                ? Number(key) === 45 && v > 1
                  ? v
                  : v * 100
                : v
              : null;
          },
        });
      }
  return out;
}
